<template>
	<div class="container2">
		<div class="main-img">
			<el-carousel :interval="5000" arrow="always" class="main-img-all">
				<el-carousel-item v-for="(item,index) in imglist" :key="index" class="main-img-lb">
					<el-image class="main-img1"
						:src="item.img"></el-image>
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="menu">
			<div class="menu1">叠加式共享充电线加盟代理</div>
			<div class="menu2">可叠加，可拆分的共享充电线设备，由控制层和多个叠加层组成，专利设计，能量工厂充电线租赁机代理加盟，样式齐全</div>
			<div class="menu3">
				<div class="product5-all">
					<div class="product5-img">
				<!-- 		<el-image class="product5-img1"
							src="//16856361.s21i.faiusr.com/2/ABUIABACGAAgr-2snwYo8L7l5AYwoAY4oAY!700x700.jpg.webp"></el-image> -->
						<img src="../../assets/img/cable/nlgc1.png"/>
					</div>
					<div class="menu3-text">
						<div class="menu3-text1">橙色共享充电线</div>
					</div>
				</div>
				<div class="product5-all">
					<div class="product5-img">
						<!-- <el-image class="product5-img1"
							src="//16856361.s21i.faiusr.com/2/ABUIABACGAAguf2snwYo0d_SggUwoAY4oAY!700x700.jpg.webp"></el-image> -->
						<img src="../../assets/img/cable/nlgc2.jpg"/>
					</div>
					<div class="menu3-text">
						<div class="menu3-text1">灰色共享充电线</div>
					</div>
				</div>
			<!-- 	<div class="product5-all">
					<div class="product5-img">
						<img src="../../assets/img/chargingjoin/3.jpg"/>
					</div>
					<div class="menu3-text">
						<div class="menu3-text1">共享充电线12口</div>
					</div>
				</div>
				<div class="product5-all">
					<div class="product5-img">
						<img src="../../assets/img/chargingjoin/4.jpg"/>
					</div>
					<div class="menu3-text">
						<div class="menu3-text1">共享充电线16口</div>
					</div>
				</div> -->
			</div>
		</div>
		<div class="product">
			<div class="product1">能量工厂共享充电线加盟优势</div>
			<div class="product3">
				<div class="product3-img">
					<!-- <el-image class="product3-img1"
						src="//16856361.s21i.faiusr.com/2/ABUIABACGAAg57LOmgYomI7p_AUwoAY46Ac.jpg.webp"></el-image> -->
					<!-- <img src="../../assets/img/chargingjoin/5.jpg"/> -->
					<img src="../../assets/img/cable/nlgc2.jpg"/>
				</div>
				<div class="product6">
					<div class="product6-top">
						<div class="product6-top1">
							<div class="product6-top1-text1">01</div>
							<div class="product6-top1-text2">代理优势</div>
							<div class="product6-top1-text3">能量工厂共享充电线一台可做代理，人人可参与的共享经济，分润置顶100%秒结收益。</div>
						</div>
						<div class="product6-top2">
							<div class="product6-top1-text1">02</div>
							<div class="product6-top1-text2">兼容性强</div>
							<div class="product6-top1-text3">能量工厂采取3U口充电，支持安卓，苹果Lightning，TYPE-C输出，兼容市面99%智能手机。</div>
						</div>
					</div>
					<div class="product6-fot">
						<div class="product6-top1">
							<div class="product6-top1-text1">03</div>
							<div class="product6-top1-text2">售后保证</div>
							<div class="product6-top1-text3">能量工厂充电线机柜质保一年，充电线质保1年，有质量问题免费维修。24小时客服为能量工厂代理商提供保障。</div>
						</div>
						<div class="product6-top2">
							<div class="product6-top1-text1">04</div>
							<div class="product6-top1-text2">总部扶持</div>
							<div class="product6-top1-text3">根据代理商实力总部可给予扶植政策，前期占领市场，后期总部免费推荐当地客户资源。坐享其成！</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="agentjoin">
			<div class="agentjoin1">能量工厂共享充电线加盟流程</div>
			<div class="advantage1">
				<div class="advantage1-all">
					<div class="advantage1-all-img">
						<img src="//2.ss.faisys.com/image/materialLib/responsiveImage/8000083.png?v=201712181730" />
					</div>
					<div class="advantage1-all-text">
						<div class="advantage1-all-text1">咨询招商经理</div>
						<div class="advantage1-all-text2">
							通过线上咨询了解能量工厂共享充电线加盟政策，了解产品优势，对比行业后确定合作意向
						</div>
					</div>
				</div>
				<div class="advantage1-all">
					<div class="advantage1-all-img">
						<img src="//2.ss.faisys.com/image/materialLib/responsiveImage/8000084.png?v=201712181730" />
					</div>
					<div class="advantage1-all-text">
						<div class="advantage1-all-text1">签订合同和发货</div>
						<div class="advantage1-all-text2">
							能量工厂总部签约能量工厂共享充电线加盟协议，转款发货，签订合同，能量工厂当天可发货
						</div>
					</div>
				</div>
				<div class="advantage1-all">
					<div class="advantage1-all-img">
						<img src="//2.ss.faisys.com/image/materialLib/responsiveImage/8000085.png?v=201712181730" />
					</div>
					<div class="advantage1-all-text">
						<div class="advantage1-all-text1">售后服务支持</div>
						<div class="advantage1-all-text2">
							提供24小时专属售后群服务，设备硬件有质量问题1年内免费维修，专属招商人员1对1服务
						</div>
					</div>
				</div>
			</div>
		<!-- 	<div class="advantage2">
				<div class="advantage2-left">
					<img class="advantage2-left1"  src="../../assets/img/chargingjoin/6.jpeg"/>
				</div>
				<div class="advantage2-right">
					<div class="advantage2-right1">
						<div class="advantage2-right1-img">
							<img class="advantage2-right1-img1"  src="../../assets/img/chargingjoin/7.jpeg"/>
						</div>
						<div class="advantage2-right-text">密码式能量工厂共享充电线</div>
					</div>
					<div class="advantage2-right1">
						<div class="advantage2-right1-img">
							<img class="advantage2-right1-img1"  src="../../assets/img/chargingjoin/2.jpg"/>
						</div>
						<div class="advantage2-right-text">8口能量工厂共享充电线机柜</div>
					</div>
					<div class="advantage2-right1">
						<div class="advantage2-right1-img">
							<img class="advantage2-right1-img1"  src="../../assets/img/chargingjoin/9.jpg"/>
						</div>
						<div class="advantage2-right-text">能量工厂聚合物款8口彩虹机</div>
					</div>
					<div class="advantage2-right1">
						<div class="advantage2-right1-img">
							<img class="advantage2-right1-img1"  src="../../assets/img/chargingjoin/10.jpeg"/>
						</div>
						<div class="advantage2-right-text">32口43寸LED屏充电线租赁机代理</div>
					</div>
				</div>
			</div> -->
		</div>

		<div class="menu5">
			<div class="menu3-top">
				<div class="menu3-top1">能量工厂共享充电线加盟优势介绍</div>
			</div>
			<div class="menu5-1">
				<div class="menu5-all">
					<div class="menu4-all-img">
						<el-image class="menu4-all-img1"
							src="//16856361.s21i.faiusr.com/4/ABUIABAEGAAgk-b55QUood7cpQQwsAk4sAk!160x160.png.webp"></el-image>
						<!-- <img src="../../assets/img/cable/3.jpg"/> -->
					</div>
					<div class="menu4-all-text">代理门槛低</div>
					<div class="menu4-all-text2">
						<span>能量工厂</span>
						<span class="color-text2">共享充电线低至1台可代理，共享充电线100条可合作</span>
						<span>，低门槛招商也显示了能量工厂的品牌自信，先试用再规划，创业0风险</span>
					</div>
				</div>
				<div class="menu5-all">
					<div class="menu4-all-img">
						<el-image class="menu4-all-img1"
							src="//16856361.s21i.faiusr.com/4/ABUIABAEGAAgk-f55QUozoPtEzCwCTiwCQ!160x160.png.webp"></el-image>
					</div>
					<div class="menu4-all-text">合作分润高</div>
					<div class="menu4-all-text2">
						<span>代理商</span>
						<span class="color-text2">拥有APP独立管理后台，收益100%总部0抽成后台免费使用</span>
						<span>，租借订单实时到账，保证收益数据真实，合同可注明数据假一罚万</span>
					</div>
				</div>
				<div class="menu5-all">
					<div class="menu4-all-img">
						<el-image class="menu4-all-img1"
							src="//16856361.s21i.faiusr.com/4/ABUIABAEGAAgvvb55QUo4OqZ-wUwsAk4sAk!160x160.png.webp"></el-image>
					</div>
					<div class="menu4-all-text">售后服务好</div>
					<div class="menu4-all-text2">
						<span>合作能量工厂的代理商有专属售后服务群，客服24小时在线及时处理售后问题，</span>
						<span class="color-text2">充电线一年内有质量问题免费维修</span>
						<span>，充电线机柜免费维修，</span>
						<span class="color-text2">终身免费补宝</span>
					</div>
				</div>
				<div class="menu5-all">
					<div class="menu4-all-img">
						<el-image class="menu4-all-img1"
							src="//16856361.s21i.faiusr.com/4/ABUIABAEGAAg6fb55QUosOq1uQcwsAk4sAk!160x160.png.webp"></el-image>
					</div>
					<div class="menu4-all-text">支持OEM贴牌代工</div>
					<div class="menu4-all-text2">
						<span>在惠州拥有2万平米共享充电线生产车间，可</span>
						<span class="color-text2">提供共享充电线OEM贴牌定制</span>
						<span>，共享充电线加盟代理，硬件代工等生产服务，共享充电系统独立源码支持二次开发</span>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="fotter">
			<div class="fotter1">
				<div class="fotter1-text">
					<span class="color-text3">能量工厂</span>
					<span>官网-深圳市乐园互联网科技有限公司</span>
				</div>
				<div class="fotter1-text2">
					<div class="fotter1-text2-1">
						<span>能量工厂-全球十大</span>
						<span class="color-text">共享充电线</span>
						<span>品牌之一，</span>
						<span class="color-text2">能量工厂3c认证</span>
					</div>
					<div class="fotter1-text2-2">
						<span class="fotter1-text2-2-left color-text3">共享充电线</span>
						<span>，共享充电线加盟代理，</span>
						<span class="fotter1-text2-2-left color-text3">共享WiFi贴</span>
						<span>，酒店售货机厂家招商加盟</span>
					</div>
					<div class="fotter1-text2-3">
						<span>代理加盟咨询招商总监：王总 </span>
						<span class="color-text3">18664573264</span>
						<span> 微信同号</span>
					</div>
					<div class="fotter1-text2-4">
						<span>公司总部：广东省深圳市宝安区新桥街道上星社区上星路万科星城星宸大厦第3栋6楼整层</span>
					</div>
				</div>
			</div>
			<div class="fotter2">
				<el-image src="../../assets/img/erweim1.png"></el-image>
			</div>
		</div> -->

	</div>
</template>

<script>
	export default {
		data() {
			return {
				imglist:[
					{
						id:3,
						// img:require('../../assets/jiudianbao.jpg')
						img:require('../../assets/img/main/9.jpeg')
					},
				],

			}
		},
		methods: {

		}
	}
</script>

<style scoped>
	.container2 {
		background: #ffffff;
		padding-bottom: 20px;
	}

	/* .main-img1 {
		width: 100%;
		height: 500px;
	}
	.main-img img{
		width: 100%;
		height: 100%;
	} */
	.main-img-all {
		width: 100%;
	}
	
	.main-img-lb {
		/* height: 420px; */
	}
	::v-deep .el-carousel__container {
		min-height: 440px;
	}
	
	.main-img1 {
		width: 100%;
		height: 440px;
	}
	

	.menu {
		margin-top: 2%;
		padding-left: 12%;
		padding-right: 12%;
	}

	.menu1 {
		text-align: center;
		line-height: 34px;
		color: rgb(51, 51, 51);
		font-family: 微软雅黑;
		font-size: 20px;
	}

	.menu2 {
		font-size: 14px;
		color: rgb(102, 102, 102);
		margin-top: 1%;
	}

	.menu3 {
		margin: 4% auto;
		display: flex;
		justify-content: center;
	}

	.product5-all {
		width: 23.5%;
		margin-left: 3%;
		position: relative;
	}
	.product5-img img{
		width: 100%;
		height: 100%;
	}

	.product5-img1 {
		width: 100%;
	}

	.menu3-text {
		margin: 30px auto;
		height: 37px;
		background-color: #2ba0e8;
		color: #fff;
		align-items: center;
		cursor: pointer;
		display: flex;
		position: relative;
		justify-content: center;
		width: 80%;
		border-radius: 30px;
		padding-left: 2%;
		padding-right: 2%;
		font-size: 14px;
	}

	.menu3-text1 {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100%;
	}

	.product {
		margin-top: 30px;
		padding-left: 12%;
		padding-right: 12%;
	}

	.product1 {
		text-align: center;
		font-size: 24px;
		color: rgb(43, 160, 232);
	}

	.product2 {
		margin-top: 10px;
		text-align: center;
		font-size: 16px;
		white-space: normal;
	}

	.product3 {
		display: flex;
		margin-top: 4%;
	}

	.product3-img {
		width: 50%;
	}
	.product3-img img{
		/* width: 80%;
		height: 100%; */
		width: 60%;
		height: 96%;
	}

	.product4 {
		width: 50%;
		text-align: left;
	}

	.product3-img1 {
		width: 70%;
	}

	.product4-text1 {
		font-size: 20px;
		margin-bottom: 20px;
	}

	.product4-text2 {
		font-size: 16px;
		line-height: 30px;
	}

	.product5 {
		margin: 5% auto;
		display: flex;
		/* align-items: center; */
		/* flex-wrap: wrap; */
	}

	.product5-all {
		width: 23.5%;
		margin-left: 3%;
		position: relative;
	}

	.product5-img1 {
		width: 100%;
	}

	.product5-text {
		background: rgba(0, 0, 0, .7);
		bottom: 0;
		color: #fff;
		font-size: 15px;
		height: 44px;
		line-height: 44px;
		position: absolute;
		text-align: center;
		transform: translateZ(0);
		transition: all .3s;
		width: 100%;
	}

	.product5-text1 {
		display: inline-block;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 94%;
	}

	.product6 {
		width: 50%;
		text-align: left;

	}

	.product6-top {
		display: flex;
		align-items: center;
	}

	.product6-top1 {
		width: 42%;
	}

	.product6-top2 {
		width: 42%;
		margin-left: 14%;
	}

	.product6-top1-text1 {
		font-size: 50px;
		color: rgb(43, 160, 232);
	}

	.product6-top1-text2 {
		font-size: 17px;
		color: rgb(43, 43, 43);
		font-family: 微软雅黑;
		margin-top: 10px;
	}

	.product6-top1-text3 {
		color: rgb(102, 102, 102);
		text-align: left;
		font-size: 15px;
		line-height: 26px;
		word-break: normal;
		margin-top: 5%
	}

	.color-text {
		color: rgb(30, 80, 174);
	}
	.color-text2 {
		color: rgb(230, 74, 25);
	}
	.color-text3{
		color: rgb(73, 110, 232);
	}

	.product6-fot {
		display: flex;
		align-items: center;
		margin-top: 3%;
	}

	.agentjoin {
		margin-top: 4%;
		text-align: center;
	}

	.agentjoin1 {
		font-size: 24px;
		color: rgb(43, 160, 232);
	}

	.agentjoin2 {
		font-size: 12px;
		color: rgb(153, 153, 153);
		margin-top: 1%;
	}

	.advantage1 {
		display: flex;
		position: relative;
		margin-top: 20px;
		margin-left: 5%;
		margin-right: 5%;
		padding-top: 20px;
		flex-wrap: wrap;
	}

	.advantage1-all {
		width: 33%;
		max-width: 100%;
	}

	.advantage1-all-img img {
		width: 87px;
		height: 87px;
	}

	.advantage1-all-text1 {
		font-size: 20px;
		text-align: center;
	}

	.advantage1-all-text {
		width: 61%;
		line-height: 30px;
		margin: 15px auto;
	}

	.advantage1-all-text2 {
		font-size: 14px;
		/* color: rgb(153, 153, 153); */
	}

	.advantage1-color-text {
		color: rgb(30, 80, 174);
	}

	.advantage2 {
		margin-top: 5%;
		display: flex;
		position: relative;

	}

	.advantage2-left {
		width: 44%;
	}

	.advantage2-left1 {
		width: 100%;
		height: 97.5%;
	}

	.advantage2-right {
		width: 56%;
		margin-left: 4%;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.advantage2-right1 {
		width: 48%;
		height: 47%;
		/* flex: 1; */
		margin-right: 2%;
		position: relative;
		flex-wrap: wrap;
		margin-bottom: 2%;
	}

	.advantage2-right1-img {
		width: 90%;
	}

	.advantage2-right1-img1 {
		width: 100%;
	}

	.advantage2-right-text {
		background: rgba(0, 0, 0, .7);
		bottom: 0;
		color: #fff;
		font-size: 15px;
		height: 44px;
		line-height: 44px;
		position: absolute;
		text-align: center;
		transform: translateZ(0);
		transition: all .3s;
		width: 84%;
		margin: auto;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		padding-left: 3%;
		padding-right: 3%;
	}

	.menu5 {
		margin-top: 20px;
		background-color: #ffffff;
		padding-top: 20px;
		padding-left: 5%;
		padding-right: 5%;
		padding-bottom: 50px;
	}

	.menu3-top1 {
		color: rgb(32, 151, 243);
		font-size: 24px;
	}

	.menu5-all {
		width: 22%;
		margin-left: 2%;
		/* background: #f5f5f5; */
		padding: 3%;
		/* height: 150px; */
	}

	.menu5-1 {
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 20px;
		background: rgba(250, 250, 250, 1);

	}
	.menu4-all-text{
		margin-top: 5%;
		/* margin-top: 20px; */
		font-size: 20px;
		font-weight: bold;
	}
	.menu4-all-text2{
		margin-top: 5%;
		/* margin-top: 20px; */
		color: #999999;
		font-family: 微软雅黑;
		font-size: 14px;
		line-height: 1.8;
	}
	.menu4-all-img1{
		width: 50%;
	}
	.fotter{
		margin-top: 3%;
		padding-left: 12%;
		padding-right: 12%;
		display: flex;
	}
	.fotter1{
		width: 50%;
		text-align: left;
		line-height: 30px;
	}
	.fotter2{
		width: 50%;
	}
	.fotter1-text{
		font-size: 26px;
		color: rgb(51, 51, 51);
	}
	.fotter1-text2{
		margin-top: 3%;
	}
	.fotter1-text2-4{
		margin-top: 3%;
	}
</style>